module.exports = __webpack_public_path__ + "static/media/hc2.33b9b41d.jpg";